// extracted by mini-css-extract-plugin
export default {"root":"ErrorHeadline_root__tt6tk"};